<div class="no-data">
  <div class="no-data-wrapper">
    <div class="content">
      <div class="icon-wrapper">
        <svg-icon [src]="icon" class="icon"></svg-icon>
      </div>
      <div class="title-wrapper">
        <h2 class="title">{{ title }}</h2>
        <div class="desc">{{ desc }}</div>
      </div>
    </div>
    <svg-icon
      src="/assets/icon/icon-no-data.svg"
      class="icon no-data-pattern"></svg-icon>
  </div>
</div>
